var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "", "grid-list-md": "" } },
    [
      _c(
        "v-tabs",
        [_c("v-tab", [_vm._v("Estado de Endpoint por Patente ")])],
        1
      ),
      _c("v-divider"),
      _c(
        "v-layout",
        {
          staticStyle: { "padding-right": "10px" },
          attrs: { row: "", wrap: "" }
        },
        [
          _c(
            "v-flex",
            { attrs: { xs6: "", sm6: "", md6: "" } },
            [
              _c("v-autocomplete", {
                attrs: {
                  label: _vm.formFields.clientes.label,
                  items: _vm.clientesAll,
                  "item-text": _vm.formFields.clientes.formatItem,
                  "item-value": "id",
                  "data-vv-name": "selectedValue",
                  color: "primary",
                  clearable: true,
                  "no-data-text": "Sin resultados",
                  required: ""
                },
                model: {
                  value: _vm.formFields.clientes.value,
                  callback: function($$v) {
                    _vm.$set(_vm.formFields.clientes, "value", $$v)
                  },
                  expression: "formFields.clientes.value"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs6: "", sm6: "", md6: "" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Patente(XXXYYY)",
                  clearable: "",
                  outlined: ""
                },
                on: {
                  "click:clear": function($event) {
                    _vm.filtro = ""
                  },
                  input: _vm.filtroUpperCase
                },
                model: {
                  value: _vm.filtro,
                  callback: function($$v) {
                    _vm.filtro = $$v
                  },
                  expression: "filtro"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs6: "", sm6: "", md6: "" } },
            [
              _c(
                "v-layout",
                { attrs: { row: "" } },
                [
                  _c("v-flex", { attrs: { xs1: "", sm1: "", md1: "" } }, [
                    _c(
                      "div",
                      {
                        staticClass: "text-sm-center botones-filtros",
                        staticStyle: {
                          "padding-right": "10px",
                          "padding-left": "20px",
                          display: "block",
                          margin: "0 0 0 auto",
                          "margin-top": "15px"
                        }
                      },
                      [
                        _c(
                          "v-tooltip",
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u([
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  return [
                                    _c("v-icon", _vm._g({}, on), [
                                      _vm._v("report_problem")
                                    ])
                                  ]
                                }
                              }
                            ])
                          },
                          [
                            _c("span", [
                              _vm._v(
                                "Si desea cambiar de cliente, seleccionelo de la lista y de\n                click a 'Filtrar'"
                              )
                            ])
                          ]
                        )
                      ],
                      1
                    )
                  ]),
                  _c("v-flex", { attrs: { xs2: "", sm2: "", md2: "" } }, [
                    _c(
                      "div",
                      { staticClass: "text-sm-center botones-filtros" },
                      [
                        _c(
                          "v-btn",
                          { on: { click: _vm.handleGridReady } },
                          [
                            _c("v-icon", [_vm._v("search")]),
                            _vm._v("Filtrar\n            ")
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]),
                  _c("v-flex", { attrs: { xs2: "", sm2: "", md2: "" } }, [
                    _c(
                      "div",
                      { staticClass: "text-sm-center botones-filtros" },
                      [
                        _c(
                          "v-btn",
                          { on: { click: _vm.clearFilters } },
                          [
                            _c("v-icon", [_vm._v("clear")]),
                            _vm._v("Limpiar\n            ")
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.visible
        ? _c(
            "v-layout",
            { attrs: { row: "" } },
            [
              _c(
                "v-flex",
                { attrs: { sm4: "", md4: "" } },
                [
                  _c("v-text-field", {
                    attrs: { label: "Filtro" },
                    on: { input: _vm.filtro2UpperCase, keyup: _vm.filtroForm },
                    model: {
                      value: _vm.filtro2,
                      callback: function($$v) {
                        _vm.filtro2 = $$v
                      },
                      expression: "filtro2"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c("v-divider"),
      _vm.visible
        ? _c(
            "div",
            { staticClass: "gridcard rounded-card proveedores" },
            [
              _c("v-divider"),
              _c("ag-grid-vue", {
                staticClass: "ag-theme-material",
                staticStyle: { "font-family": "'Asap' sans-serif" },
                attrs: {
                  "dom-layout": "autoHeight",
                  "grid-options": _vm.gridOptions,
                  funcionalidadId: _vm.funcionalidad
                }
              })
            ],
            1
          )
        : _c(
            "div",
            {
              staticStyle: { overflow: "hidden" },
              attrs: { id: "withoutPatent" }
            },
            [
              _c("div", { staticStyle: { "text-align": "center" } }, [
                _c("br"),
                _c("div", { attrs: { id: "textEmpty" } }, [
                  _vm._v("No ha ingresado ninguna patente")
                ]),
                _c("img", { attrs: { src: require("@/assets/emptyIcon.png") } })
              ])
            ]
          ),
      _c("div", { staticClass: "gridcard rounded-card" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }